export const INTEREST_SESSION_MODEL_LEGACY_DRAW = 'legacy_draw_v1';
export const INTEREST_SESSION_MODEL_TRI_GROUP = 'tri_group_v1';

/** Override with REACT_APP_INTEREST_SESSION_MODEL=legacy_draw_v1 to force legacy draw. */
export const CLIENT_DEFAULT_INTEREST_SESSION_MODEL =
  process.env.REACT_APP_INTEREST_SESSION_MODEL === INTEREST_SESSION_MODEL_LEGACY_DRAW
    ? INTEREST_SESSION_MODEL_LEGACY_DRAW
    : INTEREST_SESSION_MODEL_TRI_GROUP;

export const INTEREST_TRI_GROUP_ROUND_COUNT = 3;
export const INTEREST_TRI_GROUP_ROUND_SIZE = 40;
